import { createSlice } from '@reduxjs/toolkit';

export type DownloadTransaction = {
  loading: boolean;
  error: null;
  downloadTransactions: null;
};

const initialState: DownloadTransaction = {
  loading: false,
  error: null,
  downloadTransactions: null,
};

const transactionsDownloadSlice = createSlice({
  name: 'downloadTransactions',
  initialState,
  reducers: {
    transactionsDownloadRequest(state) {
      state.loading = true;
      state.error = null;
    },
    transactionsDownloadSuccess(state) {
      state.loading = false;
      state.error = null;
    },
    transactionsDownloadFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    resetTransactionsDownloadSlice(state) {
      return initialState; // Reset the slice to its initial state
    },
  },
});

export const {
  transactionsDownloadRequest,
  transactionsDownloadSuccess,
  transactionsDownloadFailure,
  resetTransactionsDownloadSlice,
} = transactionsDownloadSlice.actions;

export default transactionsDownloadSlice.reducer;
